<ng-template #modalAddTask let-modal>
  <div class="modal-header">
    <h3 class="modal-title">{{ "ADD_TASK" | translate }}</h3>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <div class="row" [formGroup]="formGroupAdd">
      <div class="form-group col-md-9 col-12">
        <label for="title">{{ "TITLE" | translate }} <sup class="text-danger">*</sup></label>
        <input type="text" id="title" class="form-control {{ fieldHasErrors('title') ? 'is-invalid' : '' }}" formControlName="title" />
        <div class="invalid-feedback" *ngIf="formGroupAdd.controls.title.errors?.required">{{ "ERRORS.FIELD_TITLE" | translate }}</div>
        <div class="invalid-feedback" *ngIf="formGroupAdd.controls?.title?.errors?.minlength">{{ "MIN" | translate }} 3 {{ "CHARACTERS" | translate }}</div>
        <div class="invalid-feedback" *ngIf="formGroupAdd.controls?.title?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
      </div>
      <div class="form-group col-md-3 col-12">
        <label for="title">{{ "PRIORITY" | translate }}</label>
        <div class="mt-05">
          <span class="mr-1 cursor-pointer" [ngClass]="formGroupAdd.value.priority === 0 ? '' : 'opacity-35'" [ngbTooltip]="'LOW_PRIORITY' | translate" placement="bottom" (click)="setAddPriority(0)">
            <i [data-feather]="'flag'" size="20" class="text-secondary"></i>
          </span>
          <span class="mr-1 cursor-pointer" [ngClass]="formGroupAdd.value.priority === 1 ? '' : 'opacity-35'" [ngbTooltip]="'MEDIUM_PRIORITY' | translate" placement="bottom" (click)="setAddPriority(1)">
            <i [data-feather]="'flag'" size="20" class="text-warning"></i>
          </span>
          <span class="mr-1 cursor-pointer" [ngClass]="formGroupAdd.value.priority === 2 ? '' : 'opacity-35'" [ngbTooltip]="'HIGH_PRIORITY' | translate" placement="bottom" (click)="setAddPriority(2)">
            <i [data-feather]="'flag'" size="20" class="text-danger"></i>
          </span>
        </div>
      </div>
      <div class="form-group col-12">
        <label for="endDate">{{ "EXPIRE_DATE" | translate }} <sup class="text-danger">*</sup></label>
        <ng2-flatpickr id="endDate" [config]="endDate_add" formControlName="end_date" placeholder="gg/mm/aaaa"></ng2-flatpickr>
      </div>
      <div class="form-group col-12">
        <label for="users">{{ "SELECT_COLLEAGUES" | translate }} <sup class="text-danger">*</sup></label>
        <ng-select
          id="users"
          bindLabel="complete_name"
          bindValue="hash"
          formControlName="users"
          [multiple]="true"
          [searchable]="true"
          [closeOnSelect]="true"
          class="{{ fieldHasErrors('users') ? 'is-invalid' : '' }}"
          [clearable]="false"
          [openOnEnter]="false"
          [virtualScroll]="true"
          [items]="employees_list"
          [maxSelectedItems]="employee_limit"
        ></ng-select>
        <div
          class="cursor-pointer text-primary"
          (click)="assignToMySelf()"
          *ngIf="formGroupAdd.value.users?.length < employee_limit && (!formGroupAdd.value.users || (formGroupAdd.value.users && !formGroupAdd.value.users.includes(currentUser.hash)))"
        >
          {{ "ASSIGN_TO_MY_SELF" | translate }}
        </div>
      </div>
      <div class="form-group col-12" has_capability="assign_task_to_role">
        <label for="role">{{ "SELECT_ROLE" | translate }} <sup class="text-danger">*</sup></label>
        <ng-select
          id="role"
          bindLabel="name"
          bindValue="id"
          formControlName="role"
          [searchable]="true"
          [closeOnSelect]="true"
          [clearable]="false"
          [openOnEnter]="false"
          [multiple]="false"
          [virtualScroll]="true"
          [items]="rolesList"
          class="{{ fieldHasErrors('role') ? 'is-invalid' : '' }}"
        ></ng-select>
      </div>

      <div class="form-group col-12">
        <label for="description">{{ "DESCRIPTION" | translate }}</label>
        <angular-editor id="description" [config]="_utilsService.defaultEditorConfig" [formControlName]="'description'"></angular-editor>
      </div>
      <div class="mt-2 col-12">
        <div class="mb-05">
          <strong>{{ "ENTER_MULTI_FILE" | translate }}</strong>
        </div>
        <div id="file-uploader" class="custom-file">
          <input
            class="custom-file-input"
            type="file"
            lang="it"
            id="file"
            [multiple]="true"
            (change)="addFileToList($any($event).target.files)"
            accept="application/msword, application/vnd.ms-excel, text/plain, application/pdf, image/*"
          />
          <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
        </div>
      </div>
      <div class="col-12 pt-2" *ngIf="files_list_obj.length > 0">
        <div class="d-flex mb-1 flex-wrap">
          <span
            *ngFor="let file of files_list_obj; let i = index"
            class="d-flex mr-05 mb-05 badge"
            [ngClass]="{ 'badge-light-secondary': file.status === 0, 'badge-light-info': file.status === 1, 'badge-light-success': file.status === 2, 'badge-light-danger': file.status === 3 }"
          >
            <div *ngIf="file.status !== 3" [ngbTooltip]="'STATUS.' + (file.status === 0 ? 'PENDING' : file.status === 1 ? 'PROCESSING' : 'COMPLETED') | translate">{{ file.name }} ({{ file.size }})</div>
            <div *ngIf="file.status === 3" [ngbTooltip]="file.error | translate">{{ file.name }} ({{ file.size }})</div>
            <div class="ml-05 cursor-pointer" (click)="removeFileFromList(i)" *ngIf="file.status === 0">
              <i [data-feather]="'x'" class="text-danger" size="18"></i>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-start">
    <button type="button" class="btn btn-primary" (click)="save()" rippleEffect>{{ "ADD" | translate }}</button>
  </div>
</ng-template>
